import i18n from "../../plugins/I18nPlugin";

/*
 * Keys should only contain letters, numbers, '-' and '_'
 */
export function keyRule(
  message = "components.partner.PartnerManageInitializeDialog.keyRule"
): (value: any) => boolean | string {
  const keyReggaex = RegExp(/^[a-zA-Z0-9_-]*$/);
  return (value) => keyReggaex.test(value) || String(i18n.tc(message));
}

/*
 * Template keys additionally allow '.', which separates the segments of an activity
 * notification key, e.g. `appraisal.update.updatehistorystatus`, and ',', which the backend
 * keeps when it derives a key from a title (`convertToKey`). The character set therefore
 * matches the backend key validator (validKeyCharsRegex), so no key the backend mints is
 * rejected here. The hint deliberately names only '.', '-' and '_': a comma is valid but
 * should not be advertised as a way to write a key.
 */
export function templateKeyRule(message = "objects.template.keyRuleHint"): (value: any) => boolean | string {
  const templateKeyRegex = RegExp(/^[a-zA-Z0-9.,_-]*$/);
  return (value) => templateKeyRegex.test(value) || String(i18n.tc(message));
}
